import { render, staticRenderFns } from "./OrderItemLocationListing.vue?vue&type=template&id=d2a22f14&scoped=true"
import script from "./OrderItemLocationListing.vue?vue&type=script&lang=js"
export * from "./OrderItemLocationListing.vue?vue&type=script&lang=js"
import style0 from "./OrderItemLocationListing.vue?vue&type=style&index=0&id=d2a22f14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a22f14",
  null
  
)

export default component.exports